(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
const updateEstimatedDelivery = () => {
const delivery = document.querySelector('[data-estimated-delivery]');
if (!delivery) return;
const todayParts = new Intl.DateTimeFormat('en-CA', {
timeZone: 'Europe/Amsterdam',
year: 'numeric',
month: '2-digit',
day: '2-digit'
}).formatToParts(new Date());
const datePart = (type) => todayParts.find((part) => part.type === type)?.value;
const arrivalDate = new Date(Date.UTC(
Number(datePart('year')),
Number(datePart('month')) - 1,
Number(datePart('day')) + 3
));
const formattedDate = new Intl.DateTimeFormat('en-US', {
timeZone: 'UTC',
month: 'long',
day: 'numeric'
}).format(arrivalDate);
delivery.textContent = 'Delivery time: 1–3 business days · Estimated delivery: ' + formattedDate;
};
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', updateEstimatedDelivery, { once: true });
} else {
updateEstimatedDelivery();
}
document.addEventListener('submit', (event) => {
const form = event.target.closest('[data-cart-discount-form]');
if (!form) return;
const input = form.querySelector('input[name="discount"]');
const code = input && input.value.trim();
if (!code) return;
event.preventDefault();
const root = window.Shopify?.routes?.root || '/';
const rootPath = root.endsWith('/') ? root : root + '/';
const redirect = rootPath + 'cart';
window.location.assign(rootPath + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect));
});
document.addEventListener('click', (event) => {
const button = event.target.closest('[data-cart-quantity-change]');
if (!button) return;
const control = button.closest('[data-cart-quantity-control]');
const input = control && control.querySelector('input[name="updates[]"]');
const form = button.closest('form');
if (!input || !form) return;
const current = Number.parseInt(input.value, 10) || 1;
const direction = button.dataset.cartQuantityChange === 'increase' ? 1 : -1;
input.value = String(Math.max(1, current + direction));
const updateButton = form.querySelector('button[name="update"]');
if (updateButton) form.requestSubmit(updateButton);
else form.requestSubmit();
});
document.addEventListener('change', (event) => {
const input = event.target.closest('.cart-page__quantity-control input[name="updates[]"]');
if (!input) return;
input.value = String(Math.max(1, Number.parseInt(input.value, 10) || 1));
const form = input.closest('form');
if (!form) return;
const updateButton = form.querySelector('button[name="update"]');
if (updateButton) form.requestSubmit(updateButton);
else form.requestSubmit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const pages = document.querySelectorAll('[data-product-page]');
  pages.forEach((page) => {
    const deliveryEstimates = {
      NL:'4–5', BE:'4', DE:'3', FR:'4–5', GB:'3–4', US:'4–6',
      CA:'5–6', AU:'4–5', ES:'4–5', IT:'3–4', TH:'9–12',
      DK:'2–3', SE:'3–4', CH:'4–5', PT:'4–5', AT:'4–5',
      IE:'4–6', JP:'6–8', BR:'10–14', ZA:'10–14', TR:'9–13'
    };
    const countryNames = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['en'], {type:'region'}) : null;
    const renderDeliveryCountry = (country) => {
      const code = (country || '').toUpperCase();
      const days = deliveryEstimates[code];
      const validCountry = /^[A-Z]{2}$/.test(code);
      const flag = validCountry ? String.fromCodePoint(...[...code].map(c => 127397 + c.charCodeAt(0))) : '';
      const name = validCountry ? (countryNames?.of(code) || code) : '';
      const message = name && days ? flag + ' Estimated delivery to ' + name + ': ' + days + ' business days' :
        name ? flag + ' Delivery to ' + name + ': timing varies by destination.' : 'Delivery times vary by destination.';
      page.querySelectorAll('[data-country-delivery-estimate]').forEach(node => { node.textContent = message; });
    };
    renderDeliveryCountry(page.dataset.deliveryCountry);
    const storefrontRoot = window.Shopify?.routes?.root || '/';
    fetch(storefrontRoot + 'browsing_context_suggestions.json?country[enabled]=true', {mode:'same-origin'})
      .then(response => response.ok ? response.json() : null)
      .then(context => {
        const detected = context?.detected_values?.country?.handle;
        if (typeof detected === 'string' && /^[A-Z]{2}$/.test(detected)) renderDeliveryCountry(detected);
      })
      .catch(() => {});
    page.querySelectorAll('[data-studio-videos]').forEach(carousel => {
      const track = carousel.querySelector('[data-studio-track]');
      let drag;
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;
        drag = {id: event.pointerId, x: event.clientX, left: track.scrollLeft};
        track.setPointerCapture(event.pointerId);
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', event => {
        if (drag?.id !== event.pointerId) return;
        track.scrollLeft = drag.left + drag.x - event.clientX;
      });
      track.addEventListener('lostpointercapture', event => {
        if (drag?.id !== event.pointerId) return;
        drag = undefined;
        track.classList.remove('is-dragging');
      });
      const buttons = carousel.querySelectorAll('[data-studio-step]');
      const updateArrows = () => {
        if (buttons.length < 2) return;
        buttons[0].disabled = track.scrollLeft <= 1;
        buttons[1].disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      };
      track.addEventListener('scroll', updateArrows, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(updateArrows).observe(track);
      updateArrows();
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const step = track.firstElementChild.getBoundingClientRect().width + 8;
          track.scrollBy({
            left: step * Number(button.dataset.studioStep),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        });
      });
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(({target, isIntersecting}) => {
          if (isIntersecting) target.play().catch(() => {});
          else target.pause();
        });
      }, {threshold: 0.6});
      carousel.querySelectorAll('video').forEach(video => observer.observe(video));
    });
    const gallerySlides = [...page.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...page.querySelectorAll('[data-gallery-thumb]')];
    let activeSlide = 0;
    const showSlide = (index) => {
      if (!gallerySlides.length) return;
      activeSlide = (index + gallerySlides.length) % gallerySlides.length;
      gallerySlides.forEach((slide,i) => {slide.hidden = i !== activeSlide;});
      thumbs.forEach((thumb,i) => {thumb.classList.toggle('is-active',i === activeSlide);thumb.setAttribute('aria-pressed',String(i === activeSlide));});
    };
    page.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click',() => showSlide(Number(button.dataset.galleryThumb))));
    page.querySelector('[data-gallery-prev]')?.addEventListener('click',() => showSlide(activeSlide-1));
    page.querySelector('[data-gallery-next]')?.addEventListener('click',() => showSlide(activeSlide+1));

    const previewOptions = page.querySelector('[data-preview-options]');
    previewOptions?.querySelectorAll('[data-preview-value]').forEach((button) => button.addEventListener('click',() => {
      const [kind,value] = button.dataset.previewValue.split('|');
      previewOptions.querySelectorAll('[data-preview-value]').forEach((other) => {
        if (other.dataset.previewValue.startsWith(kind + '|')) {
          const active = other === button;
          other.classList.toggle('is-selected',active);
          other.setAttribute('aria-pressed',String(active));
        }
      });
      const current = previewOptions.querySelector('[data-preview-current="' + kind + '"]');
      const summary = previewOptions.querySelector('[data-preview-summary="' + kind + '"]');
      if (current) current.textContent = value;
      if (summary) summary.textContent = value;
    }));
    const qualityFormatForValue = (value) => {
      const normalized = String(value || '').toLowerCase();
      return /(museum|acrylic|plexiglass|paper|poster|framed|frame)/.test(normalized) ? 'acrylic' : 'canvas';
    };
    const qualityTabs = page.parentElement?.querySelector('[data-quality-tabs]') || document.querySelector('[data-quality-tabs]');
    qualityTabs?.querySelectorAll('[data-quality-tab]').forEach((button) => button.addEventListener('click',() => {
      const selectedTab = button.dataset.qualityTab;
      qualityTabs.querySelectorAll('[data-quality-tab]').forEach((tab) => {
        const active = tab === button;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',String(active));
      });
      qualityTabs.querySelectorAll('[data-quality-panel]').forEach((panel) => { panel.hidden = panel.dataset.qualityPanel !== selectedTab; });
      const formatGroup = page.querySelector('.product-option--format[data-option-position]');
      if (formatGroup) {
        const formatButtons = [...formatGroup.querySelectorAll('[data-option-value]')];
        const targetButton = formatButtons.find((optionButton) => qualityFormatForValue(optionButton.dataset.optionValue) === selectedTab)
          || formatButtons[selectedTab === 'acrylic' ? 1 : 0];
        if (targetButton && !targetButton.classList.contains('is-selected')) targetButton.click();
      }
    }));
    const variantsNode = page.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const form = page.querySelector('[data-product-form]');
    const variantInput = page.querySelector('[data-current-variant]');
    const submit = page.querySelector('[data-product-submit]');
    const submitLabel = page.querySelector('[data-product-submit-label]');
    const submitPrice = page.querySelector('[data-product-submit-price]');
    const priceNode = page.querySelector('[data-product-price]');
    const compareNode = page.querySelector('[data-product-compare]');
    const statusNode = page.querySelector('.product-status');
    const currency = page.dataset.storeCurrency || 'EUR';
    const formatMoney = (cents) => new Intl.NumberFormat('en-NL',{style:'currency',currency}).format(Number(cents || 0)/100);
    const initialVariant = variants.find((variant) => String(variant.id) === variantsNode?.dataset.initialVariant) || variants.find((variant) => variant.available) || variants[0];
    const selected = initialVariant?.options ? [...initialVariant.options] : [];
    const displayOptionValue = (value) => {
      const normalized = String(value || '').toLowerCase();
      if (normalized.includes('gallery canvas')) return 'Gallery Canvas';
      if (normalized.includes('museum acrylic')) return 'Museum Acrylic';
      return value || '';
    };
    const formatOptionGroup = page.querySelector('.product-option--format[data-option-position]');
    const formatOptionPosition = Number(formatOptionGroup?.dataset.optionPosition ?? 0);
    const syncGalleryToSelectedFormat = (variant) => {
      if (!gallerySlides.length) return;
      const selectedFormat = selected[formatOptionPosition] || variant?.options?.[formatOptionPosition] || '';
      const targetFormat = qualityFormatForValue(variant?.title || selectedFormat);
      const featuredImageId = String(page.dataset.productFeaturedImageId || '');
      const variantImageId = String(variant?.featured_image_id || '');
      const hasVariantSpecificImage = variantImageId && variantImageId !== featuredImageId;
      let targetIndex = hasVariantSpecificImage
        ? gallerySlides.findIndex((slide) => String(slide.dataset.galleryImageId || '') === variantImageId)
        : -1;
      if (targetIndex < 0) {
        const formatImageId = String(targetFormat === 'acrylic' ? page.dataset.formatAcrylicImageId || '' : page.dataset.formatCanvasImageId || '');
        if (formatImageId) targetIndex = gallerySlides.findIndex((slide) => String(slide.dataset.galleryImageId || '') === formatImageId);
      }
      if (targetIndex < 0) {
        const matchingFormatVariant = variants.find((item) =>
          item.featured_image_id &&
          String(item.featured_image_id) !== featuredImageId &&
          qualityFormatForValue(item.title) === targetFormat
        );
        if (matchingFormatVariant) {
          const matchingImageId = String(matchingFormatVariant.featured_image_id);
          targetIndex = gallerySlides.findIndex((slide) => String(slide.dataset.galleryImageId || '') === matchingImageId);
        }
      }
      if (targetIndex < 0) targetIndex = gallerySlides.findIndex((slide) => slide.dataset.galleryFormat === targetFormat);
      if (targetIndex < 0) targetIndex = gallerySlides.findIndex((slide) => String(slide.dataset.galleryImageId || '') === featuredImageId);
      if (targetIndex < 0) targetIndex = 0;
      showSlide(targetIndex);
    };
    const syncQualityTabToSelectedFormat = (variant) => {
      if (!qualityTabs) return;
      const selectedFormat = selected[formatOptionPosition] || variant?.options?.[formatOptionPosition] || '';
      const targetFormat = qualityFormatForValue(selectedFormat);
      qualityTabs.querySelectorAll('[data-quality-tab]').forEach((tab) => {
        const active = tab.dataset.qualityTab === targetFormat;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });
      qualityTabs.querySelectorAll('[data-quality-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.qualityPanel !== targetFormat;
      });
    };
    const updateVariant = () => {
      const candidate = variants.find((variant) => variant.options.every((value,i) => value === selected[i]));
      if (!candidate) {
        submit.disabled = true;
        submitLabel.textContent = 'Unavailable';
        syncGalleryToSelectedFormat();
        syncQualityTabToSelectedFormat();
        return;
      }
      variantInput.value = candidate.id;
      priceNode.textContent = formatMoney(candidate.price);
      submitPrice.textContent = formatMoney(candidate.price);
      const onSale = candidate.compare_at_price && candidate.compare_at_price > candidate.price;
      compareNode.textContent = onSale ? formatMoney(candidate.compare_at_price) : '';
      compareNode.hidden = !onSale;
      submit.disabled = !candidate.available;
      submitLabel.textContent = candidate.available ? 'Add to Cart' : 'Sold out';
      if (statusNode) {
        statusNode.classList.toggle('product-status--out',!candidate.available);
        statusNode.innerHTML = '<span></span>' + (candidate.available ? 'In stock' : 'Currently unavailable');
      }
      page.querySelectorAll('[data-option-group]').forEach((group) => {
        const pos = Number(group.dataset.optionPosition);
        const current = group.querySelector('[data-option-current]');
        if (current) current.textContent = displayOptionValue(selected[pos]);
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          const active = button.dataset.optionValue === selected[pos];
          button.classList.toggle('is-selected',active);
          button.setAttribute('aria-pressed',String(active));
          const possible = variants.some((variant) => variant.available && variant.options[pos] === button.dataset.optionValue && variant.options.every((value,i) => i === pos || value === selected[i]));
          button.disabled = !possible;
        });
      });
      page.querySelectorAll('[data-summary-position]').forEach((node) => { node.textContent = displayOptionValue(selected[Number(node.dataset.summaryPosition)]); });
      syncGalleryToSelectedFormat(candidate);
      syncQualityTabToSelectedFormat(candidate);
    };
    page.querySelectorAll('[data-option-group]').forEach((group) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click',() => {
        selected[Number(group.dataset.optionPosition)] = button.dataset.optionValue;
        updateVariant();
      }));
    });
    const stickyBar = document.querySelector('[data-sticky-bar]');
    const stickyButton = document.querySelector('[data-sticky-add]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const syncSticky = () => {
      if (stickyButton && submit) stickyButton.disabled = submit.disabled;
      if (stickyPrice && priceNode) stickyPrice.textContent = priceNode.textContent;
    };
    if (stickyButton && submit) stickyButton.addEventListener('click',() => { if (!submit.disabled) form.requestSubmit(submit); });
    const updateStickyVisibility = () => {
      if (!submit || !stickyBar) return;
      const rect = submit.getBoundingClientRect();
      const submitVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      stickyBar.hidden = Boolean(submitVisible || submit.disabled);
      syncSticky();
    };
    if (submit && stickyBar) {
      window.addEventListener('scroll', updateStickyVisibility, {passive:true});
      window.addEventListener('resize', updateStickyVisibility);
      updateStickyVisibility();
    }
    const recommendations = document.querySelector('[data-recommendations]');
    const recommendationGrid = recommendations?.querySelector('[data-recommendation-grid]');
    recommendations?.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!recommendationGrid) return;
        const direction = button.hasAttribute('data-carousel-next') ? 1 : -1;
        recommendationGrid.scrollBy({ left: direction * recommendationGrid.clientWidth * 0.75, behavior: 'smooth' });
      });
    });
    if (form && submit) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (submit.disabled) return;

        const originalLabel = submitLabel?.textContent || 'Add to Cart';
        submit.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Adding…';

        try {
          const root = window.Shopify?.routes?.root || '/';
          const formData = new FormData(form);
          formData.append('sections', 'cart-drawer-section');
          formData.append('sections_url', window.location.pathname);

          const addResponse = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          const addedItem = await addResponse.json();
          if (!addResponse.ok) throw new Error(addedItem.description || addedItem.message || 'Could not add this item.');

          let sectionMarkup = addedItem.sections?.['cart-drawer-section'];
          if (!sectionMarkup) {
            const sectionResponse = await fetch(`${window.location.pathname}?sections=cart-drawer-section`, {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin'
            });
            if (sectionResponse.ok) {
              const sectionData = await sectionResponse.json();
              sectionMarkup = sectionData['cart-drawer-section'];
            }
          }
          if (!sectionMarkup) throw new Error('The cart drawer section was not returned.');

          const parsedSection = new DOMParser().parseFromString(sectionMarkup, 'text/html');
          const updatedDrawer = parsedSection.querySelector('theme-drawer#cart-drawer');
          const currentDrawer = document.querySelector('theme-drawer#cart-drawer');
          if (!updatedDrawer || !currentDrawer) throw new Error('The cart drawer is not available.');

          currentDrawer.replaceWith(updatedDrawer);

          const cartResponse = await fetch(`${root}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            const bubble = document.querySelector('.cart-bubble');
            const bubbleCount = document.querySelector('.cart-bubble__text-count');
            if (bubble) bubble.classList.toggle('visually-hidden', cart.item_count === 0);
            if (bubbleCount) {
              bubbleCount.textContent = cart.item_count > 99 ? '' : String(cart.item_count);
              bubbleCount.classList.toggle('hidden', cart.item_count === 0);
            }
            const liveRegion = document.querySelector('[data-testid="cart-count-live-region"]');
            if (liveRegion) liveRegion.textContent = `${cart.item_count} items in cart`;
          }

          const drawer = document.querySelector('theme-drawer#cart-drawer');
          if (typeof drawer?.open === 'function') drawer.open();
          else drawer?.querySelector('dialog')?.showModal();

          if (submitLabel) submitLabel.textContent = 'Added to Cart';
          window.setTimeout(() => {
            if (submitLabel) submitLabel.textContent = originalLabel;
            submit.disabled = false;
            syncSticky();
          }, 900);
        } catch (error) {
          console.error('[product-page] Add to cart failed:', error);
          if (submitLabel) submitLabel.textContent = 'Unable to add — try again';
          window.setTimeout(() => {
            if (submitLabel) submitLabel.textContent = originalLabel;
            submit.disabled = false;
            syncSticky();
          }, 2500);
        }
      });
    }

    if (form && variants.length) updateVariant();
    syncSticky();
    if (variants.length > 1) {
      page.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click',() => requestAnimationFrame(syncSticky)));
    }
    if (submit) submit.addEventListener('change',syncSticky);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
